<template>
  <v-overlay
    v-if="overlay"
    :value="true"
    absolute
    color="transparent"
  >
    <v-progress-circular
      :size="size"
      color="rgb(11, 64, 153)"
      indeterminate
    />
  </v-overlay>

  <v-progress-circular
    v-else
    :size="size"
    color="rgb(11, 64, 153)"
    indeterminate
  />
</template>

<script>
export default {
  name: 'LKProgressCircular',
  props: {
    overlay: Boolean,
    size: Number,
  },
}
</script>
